import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { collection, query, getDocs, doc, getDoc } from "firebase/firestore";
import { db } from "../Components/Firebase";
import Loading from "../Components/Loading";
import '../Styles/Sapakim/SViewAllOrders.css';
import AdminHead from "./AdminHead";

function ViewAllOrders() {
  const { UID } = useParams();
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [customers, setCustomers] = useState({});
  const [suppliers, setSuppliers] = useState({});
  const [loading, setLoading] = useState(true);
  const [searchPhone, setSearchPhone] = useState("");
  const [selectedSupplier, setSelectedSupplier] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [availableStatuses, setAvailableStatuses] = useState([]);

  useEffect(() => {
    const fetchOrdersAndCustomers = async () => {
      try {
        const q = query(collection(db, "Orders"));
        const querySnapshot = await getDocs(q);
        let ordersList = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));

        // Sort by orderNumber descending (newest first)
        ordersList.sort((a, b) => {
          const numA = parseInt(a.orderNumber) || 0;
          const numB = parseInt(b.orderNumber) || 0;
          return numB - numA;
        });


        setOrders(ordersList);

        const statuses = [...new Set(ordersList.map(order => order.Status).filter(Boolean))];
        setAvailableStatuses(statuses);

        const customerIds = [...new Set(ordersList.map(order => order.CustomerID))];
        const customerData = {};

        for (const cid of customerIds) {
          if (!cid) continue;
          const customerDoc = await getDoc(doc(db, "Customers", cid));
          if (customerDoc.exists()) {
            customerData[cid] = customerDoc.data();
          }
        }
        setCustomers(customerData);

        const supplierIds = [...new Set(ordersList.map(order => order.SapakId).filter(id => id))];
        const supplierData = {};

        for (const sid of supplierIds) {
          const supplierDoc = await getDoc(doc(db, "Users", sid));
          if (supplierDoc.exists()) {
            supplierData[sid] = supplierDoc.data();
          }
        }
        setSuppliers(supplierData);
      } catch (err) {
        console.error("שגיאה בשליפת ההזמנות או הלקוחות:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchOrdersAndCustomers();
  }, []);

  const getCustomerInfo = (customerID) => {
    if (!customerID) return { Name: "לא זמין", PhoneNumber: "לא זמין" };
    const customer = customers[customerID] || { Name: "לא זמין", PhoneNumber: "לא זמין" };
    return {
      Name: customer.Name || "לא זמין",
      PhoneNumber: customer.PhoneNumber?.trim() || "לא זמין"
    };
  };

  const getSapakName = (sapakID) => {
    if (!sapakID) return "לא מוקצה";
    return suppliers[sapakID]?.Name || "לא מוקצה";
  };

  if (loading) return <Loading />;

  const handleViewOrder = (CDID, ORID) => {
    navigate(`/AdminHome/${UID}/ViewOrder/${CDID}/${ORID}`);
  };

  const filteredOrders = orders.filter(order => {
    const customer = getCustomerInfo(order.CustomerID);

    if (searchPhone) {
      const searchLower = searchPhone.toLowerCase();
      const phone = customer.PhoneNumber?.toLowerCase() || "";
      const name = customer.Name?.toLowerCase() || "";
      if (!phone.includes(searchLower) && !name.includes(searchLower)) {
        return false;
      }
    }

    if (selectedSupplier && order.SapakId !== selectedSupplier) {
      return false;
    }

    if (selectedStatus && order.Status !== selectedStatus) {
      return false;
    }

    return true;
  });

  const uniqueSuppliers = Object.entries(suppliers).map(([id, supplier]) => ({
    id,
    name: supplier.Name || "לא זמין"
  }));

  return (
    <>
      <AdminHead />
      <div className="sviewall-container" dir="rtl">
        <h1 className="sviewall-title">כל ההזמנות במערכת</h1>
        
        <div style={{ display: "flex", gap: "1rem", marginBottom: "1.5rem", flexWrap: "wrap" }}>
          <input
            type="text"
            placeholder="חיפוש לפי טלפון או שם"
            className="sviewall-search"
            value={searchPhone}
            onChange={(e) => setSearchPhone(e.target.value)}
            style={{
              flex: "1",
              minWidth: "250px",
              padding: "0.5rem 1rem",
              fontSize: "16px",
              borderRadius: "6px",
              border: "1px solid #ccc",
              boxSizing: "border-box"
            }}
          />
          
          <select
            value={selectedSupplier}
            onChange={(e) => setSelectedSupplier(e.target.value)}
            style={{
              flex: "1",
              minWidth: "200px",
              padding: "0.5rem 1rem",
              fontSize: "16px",
              borderRadius: "6px",
              border: "1px solid #ccc",
              boxSizing: "border-box",
              backgroundColor: "white"
            }}
          >
            <option value="">כל הסוכנים</option>
            {uniqueSuppliers.map(supplier => (
              <option key={supplier.id} value={supplier.id}>
                {supplier.name}
              </option>
            ))}
          </select>

          <select
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.target.value)}
            style={{
              flex: "1",
              minWidth: "200px",
              padding: "0.5rem 1rem",
              fontSize: "16px",
              borderRadius: "6px",
              border: "1px solid #ccc",
              boxSizing: "border-box",
              backgroundColor: "white"
            }}
          >
            <option value="">כל הסטטוסים</option>
            {availableStatuses.map((status, index) => (
              <option key={index} value={status}>
                {status}
              </option>
            ))}
          </select>
        </div>

        {filteredOrders.length === 0 ? (
          <p className="sviewall-empty">לא נמצאו הזמנות.</p>
        ) : (
          filteredOrders.map(order => {
            const customer = getCustomerInfo(order.CustomerID);
            const sapakName = getSapakName(order.SapakId);
            return (
              <div key={order.id} className="sviewall-order-card">
                <p><span className="sviewall-label">מזהה הזמנה:</span> {order.orderNumber}</p>
                <p><span className="sviewall-label">סטטוס:</span> {order.Status}</p>
                <p><span className="sviewall-label">נוצר בתאריך:</span> {order.createdAt?.toDate().toLocaleString()}</p>
                <p><span className="sviewall-label">שם לקוח:</span> {customer.Name}</p>
                <p><span className="sviewall-label">טלפון:</span> {customer.PhoneNumber}</p>
                <p><span className="sviewall-label">שם סוכן:</span> {sapakName}</p>
                <button
                  className="sviewall-button"
                  onClick={() => handleViewOrder(order.CustomerID, order.id)}
                >
                  צפייה בהזמנה
                </button>
              </div>
            );
          })
        )}
      </div>
    </>
  );
}

export default ViewAllOrders;
